import _ from 'lodash'
import moment from 'moment/moment'
import { call, put } from 'redux-saga/effects'

import { partnerApiRequest } from 'core/service-wrapper/partner-api/handler-request/service-request'
import { partnerApiSubmitValidation } from 'core/service-wrapper/partner-api/handler-request/service-submit-validation'
import { setAppValue } from 'e-submission/apps/actions'
import { partnerUpdateUseLegacySubmissionWrapper } from 'quick-quote/actions'

export function createESubmissionPolicy() {
  function generatePdfProps(quickQuotePdfProps, esubPdfProps) {
    const biProps = _.cloneDeep(quickQuotePdfProps)
    const { insured, payer } = esubPdfProps

    biProps.data.effectiveDate = moment().format('YYYY-MM-DD')
    biProps.data.insureds[0].firstName = insured.firstName
    biProps.data.insureds[0].lastName = insured.lastName

    if (biProps.data.payers?.length && !_.isEmpty(payer)) {
      biProps.data.payers[0].firstName = payer.firstName
      biProps.data.payers[0].lastName = payer.lastName
    }

    return biProps
  }

  function* updatePartnerSubmissionFlagIfNeeded(policy) {
    // policy.useLegacySubmission is set on createPolicy and disable e-submission with product or category from middleware
    if (_.get(policy, 'useLegacySubmission', false) === true) {
      yield put(partnerUpdateUseLegacySubmissionWrapper(true))
      yield put(setAppValue('quickQuote.selectedDisplayProduct.useLegacySubmission', true))
    }
  }

  function* createPolicy(user, reqPayload) {
    const data = yield call(partnerApiSubmitValidation.fromESubmissionForCreate, reqPayload, user)
    const result = yield call(partnerApiRequest.createPolicy, user, data)
    const policyId = result.policyNumber ?? result.policyId
    if (policyId) {
      yield updatePartnerSubmissionFlagIfNeeded(result)
      return {
        policyId,
      }
    } else {
      throw new Error(`Unable to create policy: ${(result.errors ?? []).join(', ')}`)
    }
  }

  function* updatePolicy(user, policyId, reqPayload) {
    const data = yield call(partnerApiSubmitValidation.fromESubmissionForUpdate, reqPayload, user, policyId)
    const result = yield call(partnerApiRequest.updatePolicy, user, policyId, data)
    const policyNumber = result.policyNumber ?? result.policyId
    if (policyNumber) {
      yield updatePartnerSubmissionFlagIfNeeded(result)
      return {
        policyId: policyNumber,
      }
    } else {
      throw new Error(`Unable to update policy ${(result.errors ?? []).join(', ')}`)
    }
  }

  return {
    generatePdfProps,
    createPolicy,
    updatePolicy,
  }
}
